"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _package = _interopRequireDefault(require("../package.json"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MODULE_NAME = 'sdk/config';

var logger = _loglevel.default.getLogger(MODULE_NAME);

var NO_SDK_CONFIG = 'NO_SDK_CONFIG';
/**
 *
 * @type {{url: string}}
 */

var browserMock = {
  url: 'https://localhost'
};
/**
 * Prepare default config for modules
 * @type {string}
 */

var url = global.location ? global.location.hostname : browserMock.url;
/**
 *
 * @type {{
 *      appName: string,
 *      apiURL: string,
 *      portalURL: string,
 * }}
 * @private
 */

var defaultConfig = {
  appName: _package.default.name,
  apiURL: _package.default.config.apiURL.replace('*', url),
  portalURL: _package.default.config.portalURL.replace('*', url)
};
/**
 *
 * @type {{
 *      appName: string,
 *      apiURL: string,
 *      portalURL: string,
 * }}
 * @private
 */

var config = _objectSpread({}, defaultConfig);

logger.info("".concat(MODULE_NAME, " - config"), config);
/**
 * @param options
 * @private
 */

var logConfigError = function logConfigError(options) {
  logger.info("".concat(MODULE_NAME, " - logConfigError called"), options);

  if (!options.appName) {
    console.error('configure - appName required');
  }

  if (!options.apiURL) {
    console.error('configure - apiURL required');
  }

  if (!options.portalURL) {
    console.error('configure - portalURL required');
  }
};
/**
 *
 * @param {{
 *      appName: string,
 *      apiURL: string,
 *      portalURL: string,
 * }} options
 * @returns {boolean}
 */


var configure = function configure(options) {
  logger.info("".concat(MODULE_NAME, " - configure called"), options); // override the default config values with options

  var conf = _objectSpread(_objectSpread({}, defaultConfig), options); // all config properties must be set, this will prevent null values from continuing


  var error = !conf.appName || !conf.apiURL || !conf.portalURL; // log error to console if the configuration is invalid

  if (error && !conf.test) {
    logConfigError(conf);
    return false;
  }

  config = conf;
  return true;
};
/**
 *
 * @returns {{
 *      appName: string,
 *      apiURL: string,
 *      portalURL: string,
 * }}
 */


var getConfiguration = function getConfiguration() {
  logger.debug("".concat(MODULE_NAME, " - getConfiguration called"));
  return config;
};
/**
 *
 * @returns {boolean}
 */


var hasValidConfig = function hasValidConfig() {
  logger.debug("".concat(MODULE_NAME, " - hasValidConfig called"));
  return !(!config || !config.appName || !config.apiURL || !config.portalURL);
};

var _default = {
  NO_SDK_CONFIG: NO_SDK_CONFIG,
  configure: configure,
  getConfiguration: getConfiguration,
  hasValidConfig: hasValidConfig
};
exports.default = _default;
module.exports = exports.default;